import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Skeleton,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";

interface MarketIndex {
  symbol: string;
  name: string;
  price: number;
  changePercent: number;
}

interface MarketData {
  indices: MarketIndex[];
}

interface MarketOverviewProps {
  data: MarketData | null;
  loading: boolean;
}

export const MarketOverview: React.FC<MarketOverviewProps> = ({
  data,
  loading,
}) => {
  if (loading) {
    return (
      <Box>
        <Typography variant="h6" gutterBottom>
          Market Overview
        </Typography>
        <Grid container spacing={2}>
          {[1, 2, 3].map((i) => (
            <Grid item xs={12} sm={4} key={i}>
              <Skeleton variant="rectangular" height={100} />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Market Overview
      </Typography>
      <Grid container spacing={2}>
        {data?.indices.map((index: MarketIndex) => (
          <Grid item xs={12} sm={4} key={index.symbol}>
            <Card>
              <CardContent>
                <Typography variant="subtitle2" color="text.secondary">
                  {index.name}
                </Typography>
                <Typography variant="h5">${index.price.toFixed(2)}</Typography>
                <Box display="flex" alignItems="center" mt={1}>
                  {index.changePercent >= 0 ? (
                    <TrendingUpIcon color="success" fontSize="small" />
                  ) : (
                    <TrendingDownIcon color="error" fontSize="small" />
                  )}
                  <Typography
                    variant="body2"
                    color={
                      index.changePercent >= 0 ? "success.main" : "error.main"
                    }
                    ml={0.5}
                  >
                    {index.changePercent >= 0 ? "+" : ""}
                    {index.changePercent.toFixed(2)}%
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
